import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: '•	Improving Healthcare Access',
      position: 'Ceo & Founder',
      image: 'testimonials-1.jpg',
      quote: 'Expanding access to essential medicines in under-served regions.'
    },
    {
      name: '•	Health Awareness Programs',
      position: 'Designer',
      image: 'testimonials-2.jpg',
      quote: 'Educating communities on health and wellness.'
    },
    {
      name: '•	Supporting Healthcare Infrastructure',
      position: 'Store Owner',
      image: 'testimonials-3.jpg',
      quote: 'Contributing to the development of local healthcare facilities and services'
    }
  ];

  return (
    <section id="testimonials" className="testimonials section light-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>CSR</h2>
        <p>At Swotonn Labs , we believe in making a positive impact on society. Our CSR initiatives focus on:</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="swiper init-swiper" data-speed="600" data-delay="5000" data-breakpoints='{"320": {"slidesPerView": 1, "spaceBetween": 40}, "1200": {"slidesPerView": 3, "spaceBetween": 40}}'>
          <div className="swiper-wrapper">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="swiper-slide">
                <div className="testimonial-item">
                  <p>
                    <h3>{testimonial.name}</h3>
                    <i className="bi bi-quote quote-icon-left"></i>
                    <span>{testimonial.quote}</span>
                    <i className="bi bi-quote quote-icon-right"></i>
                  </p>
                  {/* <img src={`/assets/img/testimonials/${testimonial.image}`} className="testimonial-img" alt="" /> */}
                  {/* <h4>{testimonial.position}</h4> */}
                </div>
              </div>
            ))}
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
